import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from 'react-i18next'

import initialSetupIcon from '../../resources/images/livenessIcon.svg'
import mobileSdkIcon from '../../resources/images/mobile-sdk-1.svg'
import kvalifikaDocIcon from '../../resources/images/kvalifika-docs-1.svg'
import apiReferenceIcon from '../../resources/images/ap-reference-1.svg'

import {
	StyledMainContainer,
	StyledDropDownContentDefault,
	StyledLink,
	StyledButton,
	StyledIcon,
	StyledTitleLink
} from './DropDownMenuStyle'

const DocsDropDown = ({ darkColor, headerBackground }) => {
	const { t } = useTranslation()
	const [show, setShow] = useState(false)

	const onMouseEnter = () => setShow(true)
	const onMouseLeave = () => setTimeout(() => setShow(false), 300)

	return (
		<StyledMainContainer onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
			<StyledButton headerBackground={headerBackground} darkColor={darkColor} onClick={() => setShow(!show)}>
				{t('docs')}
			</StyledButton>
			<StyledDropDownContentDefault show={show}>
				<StyledLink target='blank' to='https://kvalifika.gitbook.io/kvalifika-1/initial-setup/setup'>
					<StyledIcon width='20' height='18' src={initialSetupIcon} alt='' />
					<StyledTitleLink>{t('initialSetup')}</StyledTitleLink>
				</StyledLink>
				<StyledLink target='blank' to='https://github.com/kvalifika/'>
					<StyledIcon width='20' height='18' src={mobileSdkIcon} alt='' />
					<StyledTitleLink>{t('mobileSDKs')}</StyledTitleLink>
				</StyledLink>
				<StyledLink target='blank' to='https://kvalifika.gitbook.io/kvalifika-1/'>
					<StyledIcon width='20' height='18' src={kvalifikaDocIcon} alt='' />
					<StyledTitleLink>{t('kvalifikaDocs')}</StyledTitleLink>
				</StyledLink>
				<StyledLink target='blank' to='https://github.com/Kvalifika/kvalifika-web-sdk'>
					<StyledIcon width='20' height='18' src={apiReferenceIcon} alt='' />
					<StyledTitleLink>{t('apiReference')}</StyledTitleLink>
				</StyledLink>
			</StyledDropDownContentDefault>
		</StyledMainContainer>
	)
}

DocsDropDown.propTypes = {
	value: PropTypes.string,
	onClick: PropTypes.func,
	headerBackground: PropTypes.bool
}
export default DocsDropDown
